import React from 'react';

const TextToHtml = (text) => {
    return text.replace(/\n/g, '<br/>');
};

function truncateString(str, num) {
    if(!str)return ""
    if (str.length <= num) {
        return str;
    }
    return str.slice(0, num) + '...';
}

export { TextToHtml, truncateString };
